const Json2csvParser = require('json2csv').Parser;
const csvFunctions = {};

csvFunctions.generate = (fields, data) => {
  const json2csvParser = new Json2csvParser({ fields });
  const csv_file = json2csvParser.parse(data, { fields });

  return csv_file;
};

export default csvFunctions;
